import { createContext, useContext, useEffect } from 'react';

export type PromoSlotEntry = {
  id: string;
  priority: number;
  shouldShow: boolean;
};

export type PromoSlotContextValue = {
  registerEntry: (entry: PromoSlotEntry) => () => void;
  activeEntryId: string | null;
};

export const PromoSlotContext = createContext<PromoSlotContextValue | null>(null);

export const usePromoSlotContext = (): PromoSlotContextValue => {
  const context = useContext(PromoSlotContext);
  if (context === null) {
    throw new Error('usePromoSlotEntry must be used within a GlobalPromoSlot');
  }
  return context;
};

export const usePromoSlotEntry = ({ id, priority, shouldShow }: PromoSlotEntry) => {
  const { registerEntry, activeEntryId } = usePromoSlotContext();

  useEffect(() => {
    return registerEntry({ id, priority, shouldShow });
  }, [registerEntry, id, priority, shouldShow]);

  return { shouldRender: activeEntryId === id };
};
